import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=241d7661&scoped=true"
import script from "./resetPass.vue?vue&type=script&lang=js"
export * from "./resetPass.vue?vue&type=script&lang=js"
import style0 from "./resetPass.vue?vue&type=style&index=0&id=241d7661&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d7661",
  null
  
)

export default component.exports